<div class="row align-items-end">
  <div class="col-sm-6 text-center" *ngIf="!isGettingEnvasado">
    <div>
      <small id="envasado-dates" class="text-muted">
        Creado: {{ envasado.createdAt | dateFormat | dateWithoutSeconds }}
        <br />
        Actualizado: {{ envasado.updatedAt | dateFormat | dateWithoutSeconds }}
      </small>
    </div>
    <div class="divCenter gap-12">
      <button
        id="envasado-details-reject"
        type="button"
        class="btn btn-outline-danger-new my-2"
        (click)="onRejectEnvasado()"
        *ngIf="envasadoCanBeRejected && showButton('reject')"
      >
        Rechazar
      </button>
      <button
        id="envasado-details-approve"
        type="button"
        class="btn btn-outline-primary-new my-2"
        (click)="onApproveEnvasado()"
        *ngIf="envasadoNeedsApproval && showButton('approve')"
      >
        Aprobar
      </button>
    </div>
  </div>
  <div class="col-sm-6 text-end">
    <div class="btn-group" style="padding-top: 60px">
      <div ngbDropdown class="d-inline-block">
        <button
          type="button"
          class="btn btn-outline-primary dropdownButton mx-2 dropdownButton-new"
          id="envasado-details-actions"
          *ngIf="!isGettingEnvasado && showButton('actions')"
          ngbDropdownToggle
        >
          Acciones
          <span class="material-symbols-outlined"> keyboard_arrow_down </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownActions">
          <a
            id="envasado-details-edit"
            *ngIf="!isGettingEnvasado && showButton('edit')"
            (click)="onEditEnvasado()"
            class="dropdown-item"
            ngbDropdownItem
          >
            Actualizar documentos</a
          >
          <a
            id="Envasado-details-reprocesing"
            *ngIf="!isGettingEnvasado && isAdmin"
            [disabled]="!isReprocesingAvailable()"
            (click)="OnReprocesiing()"
            class="dropdown-item"
            ngbDropdownItem
            >Reprocesar</a
          >
          <div class="dropdown-divider"></div>
          <a
            id="envasado-details-archive"
            *ngIf="!isGettingEnvasado && showButton('archive')"
            (click)="onArchiveEnvasado()"
            ngbDropdownItem
          >
            Archivar</a
          >
          <a
            id="envasado-details-delete"
            *ngIf="!isGettingEnvasado && showButton('delete')"
            (click)="onDeleteEnvasado()"
            ngbDropdownItem
          >
            Borrar</a
          >
        </div>
      </div>
      <button
        id="envasado-details-refresh"
        class="btn-refresh-details"
        *ngIf="!isGettingEnvasado"
        (click)="onRefreshEnvasado()"
      >
        <span class="material-symbols-outlined"> refresh </span>
      </button>
    </div>
  </div>
</div>
<div class="row mt-3">
  <div class="col-sm-6 text-center my-5" *ngIf="isGettingEnvasado">
    <app-spinner message="Cargando detalles del vehículo..."></app-spinner>
  </div>
  <div
    class="col-sm-6 box-details-cab"
    [ngStyle]="{ border: '3px solid ' + getColor() }"
    *ngIf="!isGettingEnvasado"
  >
    <div class="div-box-sap-id">
      <h4 [ngStyle]="{ color: getColor(), 'font-weight': 'bold' }">
        SAP ID: {{ envasado.sapId! | sapId }}
      </h4>
    </div>
    <div style="display: inline">
      <p><strong>Transportista</strong>: <br />{{ envasado.carrier!.name }}</p>
      <p><strong>Patente</strong>: <br />{{ envasado.licensePlate }}</p>
      <div class="divCenter" style="text-align: center">
        <p *ngIf="showBlockingMotives">
          <strong
            >Bloqueado el
            {{
              envasado.lastStatusInformedAt || envasado.updatedAt
                | dateFormat
                | dateWithoutSeconds
            }}
            por</strong
          >:<br />
          <span
            class="badge border rounded-4 text-bg-light mx-1"
            *ngFor="let motive of envasado.blockingMotives"
          >
            {{ motive }}
          </span>
        </p>
      </div>
    </div>

    <div class="divCenter">
      <h5>
        <span
          class="badge"
          [ngStyle]="{ 'background-color': getColor() }"
          style="width: 200px; border-radius: 60px"
        >
          <span>
            <img
              [src]="getImageSrc(envasado.status)"
              height="25"
              width="25"
              alt="Estado"
            />
          </span>
          {{ envasado.status | master : "VEHICLES#STATUSES" }}
        </span>
      </h5>
      <div *ngIf="hasComment">
        <label
          class="custom-file-upload pt-2 mx-1 float-end text-secondary"
          style="cursor: pointer"
        >
          <a id="entity-comment" title="Comentario" (click)="onViewComment()">
            <span class="material-symbols-outlined">comment</span>
          </a>
        </label>
      </div>
    </div>
    <div class="divCenter mb-2" *ngIf="hasComment && showComment">
      <div class="collapse comment" [ngClass]="showCommentClass()">
        <div class="card card-body">
          {{ envasado.comment }}
        </div>
      </div>
    </div>

    <div class="divCenter">
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasToExpireDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            envasado.documentsToExpire
          }}</span>
          Por vencer</span
        >
      </h6>
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasExpiredDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            envasado.documentsExpired
          }}</span>
          Vencido</span
        >
      </h6>
    </div>

    <div ngbAccordion style="padding: 10px">
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader>
          <button id="envasado-details-accordion" ngbAccordionButton>
            Ver detalles
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="table-container">
            <ng-template>
              <table class="table table-hover">
                <caption>
                  Detalles del Vehículo
                </caption>
                <tbody>
                  <tr>
                    <th scope="row">Centro</th>
                    <td>{{ envasado.originalCenter! | master : "CENTERS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Marca</th>
                    <td>{{ envasado.brand | master : "VEHICLES#BRANDS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Modelo</th>
                    <td>{{ envasado.model }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Año de Fabricación</th>
                    <td>{{ envasado.year }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Antigüedad</th>
                    <td
                      [ngClass]="
                        getEnvasadoAgeClass(currentYear - envasado.year)
                      "
                    >
                      {{ currentYear - envasado.year }} año{{
                        currentYear - envasado.year === 1 ? "" : "s"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Color</th>
                    <td>{{ envasado.color | master : "VEHICLES#COLORS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Tipo</th>
                    <td>{{ envasado.type | master : "ENVASADOS#TYPES" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Motor</th>
                    <td>
                      {{
                        envasado.engineType! | master : "ENVASADOS#ENGINE_TYPES"
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Carrocería</th>
                    <td>
                      {{ envasado.bodyType! | master : "ENVASADOS#BODY_TYPES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Capacidad</th>
                    <td>
                      {{ envasado.capacity | master : "ENVASADOS#CAPACITIES" }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Máximo de Pallets</th>
                    <td>{{ envasado.maximumPalletCapacity }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Alto x Ancho x Largo (metros)</th>
                    <td>
                      {{ envasado.height }} x {{ envasado.width }} x
                      {{ envasado.length }}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Usado en Minería</th>
                    <td>{{ envasado.forMining ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Acreditación Ranchera</th>
                    <td>{{ envasado.hasRanchAccreditation ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Es Spot</th>
                    <td>{{ envasado.isSpot ? "Sí" : "No" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">GPS IMEI</th>
                    <td>{{ envasado.gpsImei }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Cámara IMEI</th>
                    <td>{{ envasado.cameraImei }}</td>
                  </tr>
                  <tr>
                    <th class="align-middle" scope="row">Centro de Apoyo</th>
                    <td>
                      <div>
                        <label
                          *ngIf="showButton('edit-center')"
                          class="float-start me-1"
                          style="cursor: pointer"
                        >
                          <a
                            id="update-center"
                            title="Actualizar Centro de Apoyo"
                            (click)="onUpdateEnvasado()"
                          >
                            <span
                              class="material-symbols-outlined text-secondary"
                              >edit_square</span
                            >
                          </a>
                        </label>
                        {{ envasado.center | master : "CENTERS" }}
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="envasado.archiveId">
                    <th scope="row">Archivo</th>
                    <td>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                      >
                        <a
                          id="envasado-archive-details"
                          title="Visualizar Detalle"
                          (click)="onViewArchiveDetails()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >docs</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="preview-archive-docs"
                          title="Visualizar Documento"
                          (click)="onViewDocumentArchive()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >preview</span
                          >
                        </a>
                      </label>
                      <label
                        class="custom-file-upload pt-2 mx-1"
                        style="cursor: pointer"
                        *ngIf="hasDocumentOnArchive()"
                      >
                        <a
                          id="download-envasado-archive-docs"
                          title="Descargar Documento"
                          (click)="onDownloadArchiveDocument()"
                        >
                          <span class="material-symbols-outlined text-secondary"
                            >download</span
                          >
                        </a>
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="hasAgrement" ngbAccordion>
      <app-commercial-agreements-details
        [agreement]="agreement"
        [isColapsed]="isColapsed"
      ></app-commercial-agreements-details>
    </div>
  </div>
  <div class="col-sm-6">
    <app-documents></app-documents>
  </div>
</div>

<!-- Modals -->
<ng-template #envasadoModal let-c="close" let-d="dismiss">
  <app-modal-with-comment
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [showCommentForm]="modalWithComment"
    [mandatoryComment]="isBeingRejected"
    [commentForm]="commentForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-with-comment>
</ng-template>

<!-- Update Attribute Modal -->
<ng-template #updateEnvasadoAttributeModal let-c="close" let-d="dismiss">
  <app-modal-change-attributes
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [attributeForm]="updateAttributeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-change-attributes>
</ng-template>

<!-- Archive Modal -->
<ng-template #archiveEnvasadoModal let-c="close" let-d="dismiss">
  <app-modal-for-archiving
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [archiveForm]="archiveForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-for-archiving>
</ng-template>

<!--Archive Details Modal-->
<ng-template #envasadoArchiveDetailsModal let-c="close" let-d="dismiss">
  <app-modal-details
    [archive]="envasadoArchive?.entity"
    [updatedAt]="envasadoArchive?.updatedAt"
    [comment]="envasadoArchive?.comment"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  >
  </app-modal-details>
</ng-template>

<!--Document Viewer Modal-->
<ng-template #envasadoArchiveDocumentViewer let-c="close" let-d="dismiss">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ modalTitle }}</h4>
        <button
          id="document-item-modal-cross"
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross')"
        ></button>
      </div>
      <div class="modal-body">
        <div class="text-center my-5" *ngIf="isGettingURL">
          <app-spinner message="Generando Vista Previa"></app-spinner>
        </div>
        <pdf-viewer
          [src]="pdfSource"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="true"
          (page-rendered)="pageRendered()"
          style="width: 800px; height: 70vh"
        >
        </pdf-viewer>
      </div>
      <div class="modal-footer" *ngIf="!isGettingURL">
        <button
          id="document-item-modal-accept"
          type="button"
          class="btn btn-outline-primary"
          (click)="c('Accept')"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</ng-template>
